import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table, Typography, Button, Flex, Tag, Grid } from "antd"
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import styles from "../../index.module.css"
import { spacings } from "themes/variables"

const { Text } = Typography

export const EquipmentTable = ({ data, onEdit, onRemove }) => {
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()
  const isMobile = !screens.md

  const columns = useMemo(
    () => [
      {
        title: "Equipment Name",
        dataIndex: "name",
        key: "name",
        width: 160,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (name) => <Text fw="500">{name}</Text>
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        width: 100,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (category) => <Text>{category?.name || "-"}</Text>
      },
      {
        title: "Quantity",
        key: "quantity",
        width: 100,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Tag color="blue" bordered>
            QTY: {record.quantity ?? 0}
          </Tag>
        )
      },
      {
        title: "Actions",
        key: "action",
        align: "right",
        width: 100,
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Flex gap={spacings.XS} justify="end">
            <Button
              type="text"
              icon={<EditOutlined className={styles.editIcon} />}
              onClick={() => onEdit(record)}
              aria-label="Edit equipment"
            />
            <Button
              type="text"
              icon={<DeleteOutlined className={styles.deleteIcon} />}
              onClick={() => onRemove(record.id)}
              className={styles.removeExperienceButton}
              aria-label="Remove equipment"
            />
          </Flex>
        )
      }
    ],
    [onEdit, onRemove]
  )

  if (isMobile) {
    return (
      <Flex vertical gap={spacings.S} className="mt-s">
        {data.map((record) => (
          <div key={record.id} className={styles.mobileCard}>
            <Flex vertical gap={spacings.XS}>
              <Text fw="500">{record.name}</Text>
              <Flex gap={spacings.XS} align="center">
                <Text className={styles.mobileCardLabel}>Category:</Text>
                <Text>{record.category?.name || "-"}</Text>
              </Flex>
              <Flex gap={spacings.XS} align="center">
                <Text className={styles.mobileCardLabel}>Quantity:</Text>
                <Tag color="blue" bordered>
                  QTY: {record.quantity ?? 0}
                </Tag>
              </Flex>
            </Flex>
            <Flex gap={spacings.XS} justify="end" className={styles.mobileCardActions}>
              <Button
                type="text"
                icon={<EditOutlined className={styles.editIcon} />}
                onClick={() => onEdit(record)}
                aria-label="Edit equipment"
              />
              <Button
                type="text"
                icon={<DeleteOutlined className={styles.deleteIcon} />}
                onClick={() => onRemove(record.id)}
                className={styles.removeExperienceButton}
                aria-label="Remove equipment"
              />
            </Flex>
          </div>
        ))}
      </Flex>
    )
  }

  return <Table className={styles.equipmentTable} dataSource={data} rowKey="id" pagination={false} columns={columns} scroll={{ x: "max-content", y: 300 }} />
}

EquipmentTable.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}
